import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export function useLabels() {
  const { t } = useTranslation();

  const labels = useMemo(() => ({
    1: t('widget.veryLow'),
    2: t('widget.veryLow'),
    3: t('widget.low'),
    4: t('widget.low'),
    5: t('widget.moderate'),
    6: t('widget.moderate'),
    7: t('widget.high'),
    8: t('widget.high'),
    9: t('widget.veryHigh'),
    10: t('widget.veryHigh'),
  }), [t])

  return labels;
}
